import { reactive, toRefs } from "vue";
const initialState = {
    thema: null,
    frontendPath: null,
    topics: null,
    enableDateFilter: false,
    enableTopicFilter: false,
};
export function isTopicFilterEnabled(config) {
    return ((!config?.mandatoryTopics || config.mandatoryTopics.length === 0) &&
        Array.isArray(config?.topics) &&
        config.topics.length > 0);
}
export function useConfig() {
    const state = reactive(initialState);
    const setConfig = (config) => {
        state.thema = config.thema;
        state.frontendPath = config.frontendPath;
        state.topics = config?.topics;
        state.pastYears = config?.pastYears;
        state.enableDateFilter = config?.enableDateFilter;
        state.enableTopicFilter = config?.enableTopicFilter;
        state.noHitTxt = config?.noHitTxt;
        state.archive = config?.archive;
    };
    return {
        ...toRefs(state),
        setConfig
    };
}
